// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyStatePlaceholder_wrapper__8sKmE","message":"EmptyStatePlaceholder_message__npiYH"};